import React, { useCallback, useEffect, useState } from "react";
import { Alert, Card, Col, Container, Row } from "react-bootstrap";
import api from "../../../service/api";
import { Lists } from "./List";
import { tableColumns } from "./data";
import { Helmet } from "react-helmet-async";
import SearchRenewal from "../Schedules/SearchRenewal";
import CustomSearch from "../CommonComponents/CustomSearch";
const Renewal = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [defaultConfig, setDefaultConfig] = useState();
  const getEnrolments = useCallback(async (search) => {
    setLoading(true);
    try {
      const response = await api.get("tms/renewals?status=pending", search);
      setData(response);
      setError();
    } catch (error) {
      setLoading(false);
      setError(error.message);
      setData([]);
    }

    setLoading(false);
  }, []); //  eslint-disable-line react-hooks/exhaustive-deps

  const [searchValue, setSearchValue] = useState({
    name: "",
    fin: "",
    date: "",
    registration_type: "",
    // status: status,
    type: "",
    trade_category: "",
    type_of_trade: "",
    application_option: "",
    course_id: "",
    company_id: "",
    result_date: "",
  });
  const search = (page) => {
    const searchParam = { ...searchValue, ...page };
    getEnrolments(searchParam);
  };
  const resetSearch = () => {
    setSearchValue({
      ...searchValue,
      fin: "",
      date: "",
      registration_type: "",
    });
    getEnrolments(searchValue);
  };
  //
  // useEffects
  //

  useEffect(() => {
    getEnrolments(searchValue);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getConfig = async () => {
      const configResponse = await api.get(`tms/enrolments/config`, {});
      setDefaultConfig(configResponse.data);
    };
    getConfig();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <Helmet title="Renewals > Renewal list" />
      <Container fluid className="p-0">
        <h1 className="h3 mb-3">Renewal program</h1>
        <Card className="m-0 p-0">
          {error && (
            <Card.Header>
              <Alert className="my-3" variant="danger">
                <div className="alert-message">{error}</div>
              </Alert>
            </Card.Header>
          )}
          <Card.Body>
          <Row>
            <Col md={12}>
              <CustomSearch
                  search={search}
                  setSearchValue={setSearchValue}
                  searchValue={searchValue}
                  defaultConfig={defaultConfig}
                  isRenewalStudents
              />
            </Col>
            
          </Row><br></br>
          <Row>
            <Col md={12}>
              {loading && <div>Loading...</div>}
              {!loading && data?.data && (
                <Lists
                  columns={tableColumns}
                  rawData={data}
                  enrolmentApi={search}
                  status="pending"
                />
              )}
            </Col>
            
          </Row>
          </Card.Body>
        </Card>
      </Container>
    </React.Fragment>
  );
};

export default Renewal;
